<template>
  <div>
    <v-main>
      <v-app-bar color="primary" flat app dark>
        <v-btn style="position: absolute" icon :to="'/'">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-app-bar-title style="min-width: fit-content;">{{ $t('settings.switchNursery') }}</v-app-bar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-container fluid>
        <div class="d-flex justify-center my-5">
          <p v-if="nurserySchool">{{ $t('settings.currentNursery') }}：{{ nurserySchool.nurseryName }}</p>
        </div>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <v-select
              :items="nurserySchools"
              item-title="nurseryName"
              item-value="nurseryId"
              v-model="selectNursery"
              :label="$t('settings.selectNursery')"
              variant="outlined"
              :loading="btnLoading"
              color="primary"
            ></v-select>
          </v-col>
        </v-row>
        <div class="d-flex justify-center my-5">
          <v-btn @click="changeNursery" color="primary" block variant="outlined">
            {{ $t('settings.change') }}
          </v-btn>
        </div>
      </v-container>
      <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
        {{ snackBarText }}

        <!-- <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
            ×
          </v-btn>
        </template> -->
        <template v-slot:actions>
          <v-btn
            color="outline"
            variant="text"
            @click="snackbar = false"
          >
            ×
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </div>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
import { i18n } from '@/plugins/i18n';

import { PostMeRequest } from '@/model/Request';
import { meModule } from '@/store/dataModules/meModule';
import { auth0Module } from '@/store/dataModules/auth0Module';
import LocalDataService from '@/service/LocalDataService';
import { MeNurserySchoolResponse } from 'chaild-api/lib';

interface DataType {
  postMeRequest: PostMeRequest;
}

export default defineComponent({
  data: () => ({
    btnLoading: false,
    selectNursery: null,
    timeout: 2000,
    snackBarText: '',
    snackbar: false,
  }),
  computed: {
    nurserySchool(): MeNurserySchoolResponse | null {
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        return nurserySchool;
      }
      return null;
    },
    nurserySchools(): MeNurserySchoolResponse[] {
      const user = LocalDataService.getUser();
      if (user) {
        const nurserySchools = user.nurserySchools;
        return nurserySchools;
      }
      return [];
    },
  },

  methods: {
    async changeNursery() {
      // auth0Module.logout();
      console.log(this.selectNursery);
      if (this.selectNursery && this.nurserySchool) {
        try {
          this.btnLoading = true;
          await meModule.putMe({
            defaultNurseryId: this.selectNursery
          });
          this.snackBarText = i18n.global.t('common.saved');
          this.snackbar = true;
        } catch {
        } finally {
          this.btnLoading = false;
        }
      }
      setTimeout(this.toHome, 1000);
    },
    toHome() {
      this.$router.push('/')
    }
  },
  beforeUnmount() {
    meModule.setTabIndex('setting')
  },
});
</script>
<style lang="scss" scoped></style>
